import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useReasonNote } from 'src/components/Notes/queries';
import DEFAULT_ENUMS from 'src/reducers/constants/defaultEnums';

const ReasonNote = ({
  referral, providerId,
}) => {
  const note = useReasonNote(referral, providerId);
  const text = note?.text;
  const reason = referral?.reason;

  const referralStatus = DEFAULT_ENUMS.referrals.statuses.find(
    (status) => status.value === referral.status,
  )?.display_name;

  return (
    <div>
      {reason && (
        <p className="mb-2">
          <b>{referralStatus} Reason:</b> {reason}
        </p>
      )}
      {text && (
        <p>
          <b>Note:</b> {text}
        </p>
      )}
    </div>
  );
};

ReasonNote.propTypes = {
  referral: PropTypes.object.isRequired,
  providerId: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  referral: ownProps.referral,
  providerId: ownProps.providerId,
});

export default connect(mapStateToProps)(ReasonNote);
